import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }

import CKEditor from '@ckeditor/ckeditor5-vue';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { ref, defineAsyncComponent } from "vue"

export default /*@__PURE__*/_defineComponent({
  __name: 'indexCk',
  setup(__props) {

const Card9 = defineAsyncComponent(() => import("@/components/commen/card/cardData9.vue"))

const ckeditor = CKEditor.component
const editor = ClassicEditor
const editorData = ref<string>('<p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>')


return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "Editors",
      title: "Ck Editor"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(Card9), {
          colClass: "col-md-12 ",
          cardhaderClass: "pb-0 title-header",
          title: "cK Editor"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(ckeditor), {
              editor: _unref(editor),
              modelValue: editorData.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((editorData).value = $event))
            }, null, 8, ["editor", "modelValue"])
          ]),
          _: 1
        })
      ])
    ])
  ], 64))
}
}

})